class SampaGroupSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.track = this.querySelector('[data-card-track]');
    this.items = this.track ? Array.from(this.track.children) : [];
    this.current = this.querySelector('[data-card-current]');
    if (!this.track || this.items.length < 2) return;
    this.querySelector('[data-card-previous]')?.addEventListener('click', () => this.move(-1));
    this.querySelector('[data-card-next]')?.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.updateCurrent(), { passive: true });
    this.updateCurrent();
  }
  step() { return this.items[0].getBoundingClientRect().width; }
  move(direction) { this.track.scrollBy({ left: this.step() * direction, behavior: 'smooth' }); }
  updateCurrent() { const step = this.step(); const index = step > 0 ? Math.round(this.track.scrollLeft / step) : 0; if (this.current) this.current.textContent = String(Math.min(index + 1, this.items.length)); }
}
if (!customElements.get('sampa-group-slider')) customElements.define('sampa-group-slider', SampaGroupSlider);
